import { Injectable } from '@angular/core';

import { navigation } from 'app/navigation/navigation';

import { AuthService } from 'app/services/auth.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

import { UserModel } from 'app/models/user.model';
import { FuseNavigation } from '@fuse/types';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  // Private
  private _navigation: any;

  /**
  * Constructor
  * 
  * @param {AuthService} _authService
  * @param {FuseNavigationService} _fuseNavigationService
  */
  constructor(
    private _authService: AuthService,
    private _fuseNavigationService: FuseNavigationService,

  ) {
    // Initialize the service
    this._init();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    // Register the navigation to the service
    this._fuseNavigationService.register('main', navigation);

    // Set the main navigation as our current navigation
    this._fuseNavigationService.setCurrentNavigation('main');
  }

  private resolveNavigation(user: UserModel): void {
     // Clear Navigation on User Change (null is considered a change)
    this.resetNavigation();

    // Mostrar items que no necesitan permisos
    const navItems = this._fuseNavigationService.getFlatNavigation(navigation);
    navItems.filter(item => !item.permission?.length).forEach(navItem => {
      this.showParent(this._fuseNavigationService.getNavigationItem(navItem.id));
      this._fuseNavigationService.updateNavigationItem(navItem.id, {
        hidden: false
      });
    });

    if (!user || !user.permissions) {
      return;
    }

    user.permissions.forEach(p => {
      const permissionId = p.id.toString();

      navItems.forEach(navItem => {

        if (navItem.permission === permissionId) {

          this.showParent(this._fuseNavigationService.getNavigationItem(navItem.id));
          this._fuseNavigationService.updateNavigationItem(navItem.id, {
            hidden: false
          });
        }
      });

    });
  }

  private resetNavigation(): void {
    const currentNav = this._fuseNavigationService.getNavigation('main');
    if (currentNav && currentNav.length) {
      this._fuseNavigationService.hideAllItems(currentNav);
    }
  }

  private showParent(item: any): void {
    const parentItem = this._fuseNavigationService.getNavigationItemParent(item.id);
    if (parentItem) {
      if (parentItem.hidden) {
        this._fuseNavigationService.updateNavigationItem(parentItem.id, {
          hidden: false
        });
      }
      this.showParent(parentItem);
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  init(): void {
    this._authService.currentUser$.subscribe(
      (user) => {
        this.resolveNavigation(user);
      }
    );
  }
}
